export const MAX_BANNERS = 5;

export type Banner = { url: string; isMain?: boolean };

/**
 * Exactly one banner is main whenever there are banners: the backend answers
 * "Main value must be equal to 1!" otherwise (business profile, branch update). The first flagged one wins, else the first banner.
 */
export function ensureOneMain(banners: Banner[]): Banner[] {
  if (banners.length === 0) return [];
  const mainIndex = Math.max(
    banners.findIndex((b) => b.isMain),
    0,
  );
  return banners.map((b, index) => ({ url: b.url, isMain: index === mainIndex }));
}

/** Raw banner rows from the API, keeping only those with a url and exactly one main. */
export function normalizeBanners(raw: Banner[] | undefined | null): Banner[] {
  if (!Array.isArray(raw)) return [];
  return ensureOneMain(raw.filter((b): b is Banner => Boolean(b?.url)));
}

type UploadedImage = { url?: string; selected: boolean };

/** Banners from MultiImageUpload's list: images still uploading (no url yet) are left out. */
export function bannersFromImages(images: UploadedImage[]): Banner[] {
  return ensureOneMain(images.filter((img) => Boolean(img.url)).map((img) => ({ url: img.url as string, isMain: img.selected })));
}
